"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WingBuffettAbilityHandler = exports.WingBuffettActorAbilityFactory = exports.WingBuffettAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Stun_1 = require("../../core/effects/core/Stun");
const Registries_1 = require("../../core/state/Registries");
class WingBuffettAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.WingBuffett;
        this.__typeName = "WingBuffett";
    }
}
exports.WingBuffettAbilityArgs = WingBuffettAbilityArgs;
let WingBuffettActorAbilityFactory = class WingBuffettActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("WingBuffett", "OneEnemies", 3);
    }
};
WingBuffettActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("WingBuffett")
], WingBuffettActorAbilityFactory);
exports.WingBuffettActorAbilityFactory = WingBuffettActorAbilityFactory;
let WingBuffettAbilityHandler = class WingBuffettAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Physical", 70)
            ],
            projectileType: "MagicWind",
            projectilePath: "line",
            onHit(sequence) {
                container.applyDebuff({
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new Stun_1.StunEffectArgs(),
                    duration: Duration_1.Duration.Turns(1),
                    sequence
                });
            }
        });
    }
};
WingBuffettAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.WingBuffett)
], WingBuffettAbilityHandler);
exports.WingBuffettAbilityHandler = WingBuffettAbilityHandler;
